import React from 'react';
import { AnimatedSection } from '../components/AnimatedSection';
export function Quote() {
  return <div className="w-full" data-id="element-403" data-mp="2kq8zn08upao4">
      {/* HERO SECTION */}
      <section className="bg-navy text-white py-20 md:py-28 relative overflow-hidden" data-id="element-404" data-mp="2kncyz45mc7vz">
        <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-405" data-mp="2yg2rlrfnkb22"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center" data-id="element-406" data-mp="2ugk2ejgstdtf">
          <AnimatedSection data-id="element-407" data-mp="26owk2pxlrb2r">
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight mb-6 max-w-3xl mx-auto" data-id="element-408" data-mp="26q7z5lwi0596">
              Request a <span className="text-accent" data-id="element-409" data-mp="2fq4hl5sao7vs">Free Quote</span>
            </h1>
            <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-410" data-mp="2fo9y7vwo8ntt">
              Many projects can be evaluated faster when photos and project
              details are submitted.
            </p>
          </AnimatedSection>
        </div>
      </section>

      <section className="py-20 bg-slate-50" data-id="element-411" data-mp="3m5na697w96at">
        <div className="max-w-4xl mx-auto px-6" data-id="element-412" data-mp="vnsz18b3buju">
          <AnimatedSection data-id="element-413" data-mp="vn10bom75gpc">
            <div className="bg-white p-4 md:p-8 rounded-sm shadow-xl border border-slate-100" data-id="element-414" data-mp="vpvn3msondlx">
              {/* Jotform Embed */}
              <iframe id="JotFormIFrame-261718702954059" title="Free Quote Request" allow="geolocation; microphone; camera" src="https://form.jotform.com/261718702954059" frameBorder="0" style={{
              minWidth: '100%',
              maxWidth: '100%',
              height: '800px',
              border: 'none'
            }} scrolling="yes" data-id="element-415" data-mp="14oquh27gqtqt"></iframe>
            </div>
          </AnimatedSection>
        </div>
      </section>
    </div>;
}